// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";
// export default API_URL;

const API_URL = "https://backend-healthybite.up.railway.app";
export default API_URL;
